import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../../Svg';
import upperCaseFirst from 'upper-case-first';
import classNames from 'classnames';

const FilterOption = (props) => {
    function getOptionDisplayName() {
        return props.displayName || upperCaseFirst(props.value);
    }

    return (
        <li
            className={classNames(
                'ui-filter__option',
                {
                    'ui-filter__option_selected': props.selected,
                }
            )}
            onClick={() => props.onOptionSelect(props.name, props.value)}
        >
            <span className="ui-filter__link ui-popoverList__link">
                <span className="ui-popoverList__label">{getOptionDisplayName()}</span>
                <span className="ui-filter__icon">
                    <Svg size="Medium" iconName="tick" />
                </span>
            </span>
        </li>
    );
};

FilterOption.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    onOptionSelect: PropTypes.func.isRequired,
    selected: PropTypes.bool,
    displayName: PropTypes.string
};

export default FilterOption;



// WEBPACK FOOTER //
// ./src/js/modules/Filter/components/FilterOption.js